module.exports = __webpack_public_path__ + "img/DSC_9885.42eb3417.jpeg";